import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'

type RecurrenceSelectInputProps = {
  recurrence: boolean
  onSetRecurrence: (recurrence: boolean) => void
}

export const RecurrenceSelectInput = ({
  recurrence,
  onSetRecurrence,
}: RecurrenceSelectInputProps) => (
  <FormControl fullWidth>
    <InputLabel id='task-modal-v2-set-recurrence-select-label'>
      Task Recurrence
    </InputLabel>
    <Select
      labelId='task-modal-v2-set-recurrence-select-label'
      id='task-modal-v2-set-recurrence-select'
      value={recurrence ? 1 : 0}
      label='Task Recurrence'
      onChange={({ target }) => {
        // TODO: Break this out into a handler and clear payload on swap
        onSetRecurrence(Boolean(target.value))
      }}
    >
      <MenuItem value={0}>This task does not repeat</MenuItem>
      <MenuItem value={1}>Repeats Every</MenuItem>
    </Select>
  </FormControl>
)
